import DOMPurify from 'isomorphic-dompurify';
import * as React from 'react';
import { TMessage } from '../../../types/messages';

export const useMessageHtmlText = ({ htmlText }: TMessage) => {
  return React.useMemo(() => {
    const trimmedText = htmlText?.trim();

    const sanitizedText = trimmedText ? DOMPurify.sanitize(trimmedText) : null;

    if (!sanitizedText) {
      return null;
    }

    return sanitizedText.replace(new RegExp('\\n', 'g'), '<br/>');
  }, [htmlText]);
};
